module.exports = __webpack_public_path__ + "img/TetrisGameplay.94f3300c.png";